import React from 'react';
import Image from './../dom-elements/Image';

const Awards = (props) => {
  const AwardsItems = props.AwardsData.map((item, i) =>
    <li className={'awards-item'} key={'award-' + i}>
      <div className={'award-wrapper'}>
        <Image source={item.award_logo.large}/>
      </div> 
      <style jsx>{`
        .awards-item {
          margin-bottom: 1rem;
          width: 50%;
        }
        .awards-item:nth-child(odd) > .award-wrapper {
          padding-right: 1rem;
        }
        .awards-item:nth-child(even) > .award-wrapper {
          padding-left: 1rem;
        }
      `}</style>
    </li>
  );
  return (
    <div className={'awards-repeater'}>
      <h3 className={'small-header'}>{'Awards'}</h3>
      <ul className={'awards'}>
        {AwardsItems}
      </ul>
      <style jsx>{`
        .awards-repeater {
          display: flex;
          flex-direction: column;
        }
        .awards {
          margin-top: 1rem;
          list-style: none;
          display: flex;
          flex-direction: row;
        }
      `}</style>
    </div>
  );
};

export default Awards;



// WEBPACK FOOTER //
// ./src/components/photo-film-project/Awards.js